import React, { useState, useEffect } from 'react';
import { useStyles } from './style';
import clsx from 'clsx';
import { Checkbox } from '@mui/material';
import { CheckBoxIcon, CheckBoxIconFill } from 'components/CheckBox/CheckBoxIcon';

const CheckboxMain = ({ label, onChange, checkForce }) => {
  const classes = useStyles();
  const [isChecked, setIsChecked] = useState(false);
  useEffect(() => {
    setIsChecked(checkForce);
  }, [checkForce]);
  const handleChange = () => {
    setIsChecked(!isChecked);
    onChange(!isChecked); // Call the passed onChange function with the new state
  };

  return (
    <label className={clsx(classes.checkboxContainer, isChecked ? 'checkmark' : '')}>
      <Checkbox
        color="primary"
        onChange={handleChange}
        checked={isChecked}
        value={isChecked}
        icon={<CheckBoxIcon />}
        checkedIcon={<CheckBoxIconFill />}
      />
    </label>
  );
};

export default CheckboxMain;
